window.AppointmentBooking ??= {};
window.AppointmentBooking.Wizard ??= {};
window.AppointmentBooking.Wizard.Views ??= {};
window.AppointmentBooking.Wizard.Views.Mixins ??= {};

AppointmentBooking.Wizard.Views.Mixins.ConditionalVisibilty = (superclass) =>
  (() => {
    const Cls = class extends superclass {
      constructor() {
        super(...arguments);
        this.initialize = this.initialize.bind(this);
        this.render = this.render.bind(this);
        this.updateVisibility = this.updateVisibility.bind(this);
        this.isVisible = this.isVisible.bind(this);
        this.toggle = this.toggle.bind(this);
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
      }

      initialize(options = {}) {
        super.initialize(options);

        this.visible = true;

        if (options.condition != null) {
          this.condition = options.condition;
          if (this.model != null) {
            return this.listenTo(
              this.model,
              "change relational:change:visit_type_rule_selections relational:change:verify_id_answers",
              this.updateVisibility,
            );
          }
        }
      }

      // RENDERING

      render() {
        this.updateVisibility();
        super.render(...arguments);
        return this;
      }

      updateVisibility() {
        if (this.condition) {
          return this.toggle(!!this.condition());
        }
      }

      isVisible() {
        return this.visible;
      }

      toggle(direction = !this.visible) {
        if (direction) {
          return this.show();
        } else {
          return this.hide();
        }
      }

      show() {
        this.visible = true;
        this.$el.show();
        return this.trigger("show");
      }

      hide() {
        this.visible = false;
        this.$el.hide();
        return this.trigger("hide");
      }
    };
    return Cls;
  })();
